import { matchRoutes, RouteObject } from 'react-router-dom'

export function hasExactRouteMatch(routes: RouteObject[], path: string) : boolean {
  const matches = matchRoutes(routes, path)
  if(matches === null) {
    return false
  }

  return matches.some(match => match.pathnameBase === path)
}
